import React from "react"
import { useAppContext } from "../AppContext"
import { isObject } from "lodash"

export const useUserState = ()  => {

    const {USER, setUSER, showDiscountedPrices}= useAppContext()

    // React.useEffect(() =>
        
    //     console.log('USER', USER), [])

    const isUserLoggedIn = React.useMemo(() => {
        // return false 
        return (USER && isObject(USER) && USER.access_token.length > 0) ? true : false
    }, [USER])

    const isUserLoogedInAndShowDiscountPrices = React.useMemo(() => {
        // return false 
        return (showDiscountedPrices && USER  && isObject(USER) && USER.access_token.length > 0) ? true : false
    }, [USER, showDiscountedPrices])

    return {
        isUserLoggedIn,
        isUserLoogedInAndShowDiscountPrices
    }
}